












import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class BreadcrumbItem extends Vue {
  @Prop({ default: false }) clickable!: boolean | string;

  private onClick(): void {
    if (this.clickable) {
      this.$emit("click");
    }
  }
}
